<template>
  <div v-if="open">
    <label>File Preview</label>

    <iframe v-bind:src="url" width="100%" height="565px" frameborder="0"></iframe>
  </div>
</template>

<script>
// function copyStyles(sourceDoc, targetDoc) {}

export default {
  name: "window-portal",
  model: {
    prop: "open",
    event: "close"
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    url: {
      type: String
    }
  },
  data() {
    return {
      windowRef: null
    };
  },
  watch: {
    open(newOpen) {
      if (newOpen) {
        this.openPortal();
      } else {
        this.closePortal();
      }
    }
  },
  methods: {
    openPortal() {
      this.windowRef = window.open(
        "",
        "",
        "width=800,height=600,left=200,top=200"
      );
      this.windowRef.document.body.appendChild(this.$el);
      //   copyStyles(window.document, this.windowRef.document);
      this.windowRef.addEventListener("beforeunload", this.closePortal);
    },
    closePortal() {
      if (this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
        this.$emit("close");
      }
    }
  },
  mounted() {
    if (this.open) {
      this.openPortal();
    }
  },
  beforeDestroy() {
    if (this.windowRef) {
      this.closePortal();
    }
  }
};
</script>